import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { LoadingButton } from '@mui/lab'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useCreateKycV2PersonMutation } from '../../../../features/kycv2/kycv2Slice'
import TextInputForm from '../../../../components/common/form/TextInputForm/TextInputForm'
import styles from './styles.module.scss'

const CreatePersonForm = ({ onSubmit = () => {}, onCancel = () => {} }) => {
  const { t } = useTranslation(['common', 'messages'])
  const [_, { isLoading }] = useCreateKycV2PersonMutation({ fixedCacheKey: 'create-person-v2' })

  const schema = yup.object().shape({
    email: yup.string().email().optional(),
    firstname: yup.string().required(),
    lastname: yup.string().required(),
    externalId: yup.string().optional(),
    webhookUrl: yup.string().url().optional(),
    metadata: yup.string().optional(),
  })

  const { handleSubmit, control, formState } = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
      firstname: '',
      lastname: '',
      externalId: '',
      webhookUrl: '',
      metadata: '',
    },
  })

  const onSubmitInternal = (values) => {
    const payload = {
      ...values,
    }

    // Parse metadata if provided
    if (values.metadata) {
      try {
        payload.metadata = JSON.parse(values.metadata)
      } catch (error) {
        console.error('Invalid JSON in metadata field')
        return
      }
    }

    onSubmit(payload)
  }

  return (
    <Box component="form" className={styles.container} onSubmit={handleSubmit(onSubmitInternal)}>
      <Typography variant="title">{`${t('common:create')} ${t('common:person')}`}</Typography>
      <Box className={styles.formContainer}>
        <Box className={styles.inputField}>
          <TextInputForm
            name="firstname"
            control={control}
            label={t('common:firstName')}
            placeholder={t('common:firstName')}
          />
        </Box>
        <Box className={styles.inputField}>
          <TextInputForm
            name="lastname"
            control={control}
            label={t('common:lastName')}
            placeholder={t('common:lastName')}
          />
        </Box>
        <Box className={styles.inputField}>
          <TextInputForm name="email" control={control} label={t('common:email')} placeholder={t('common:email')} />
        </Box>
        <Box className={styles.inputField}>
          <TextInputForm
            name="externalId"
            control={control}
            label={t('common:externalId')}
            placeholder={t('common:externalId')}
          />
        </Box>
        <Box className={styles.inputField}>
          <TextInputForm
            name="webhookUrl"
            control={control}
            label={t('common:webhookUrl')}
            placeholder="https://example.com/webhook"
          />
        </Box>
        <Box className={styles.inputField}>
          <TextInputForm
            name="metadata"
            control={control}
            label={t('common:metadata')}
            placeholder='{"key": "value"}'
            multiline
            rows={3}
          />
        </Box>
      </Box>
      <Box className={styles.actionButtons}>
        <Button variant="outlined" color="secondary" onClick={onCancel} disabled={isLoading}>
          {t('common:cancel')}
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          type="submit"
          disabled={!formState.isDirty || !formState.isValid}
          loading={isLoading}
        >
          {t('common:create')}
        </LoadingButton>
      </Box>
    </Box>
  )
}

export default CreatePersonForm
